// below: box-shadow style from Figma is not giving accurate CSS styling, so use the below style instead
export const HOVER_BOXSHADOW =
  "0px 16px 12px -8px rgb(0 0 0 / 14%), 0px 6px 15px -3px rgb(0 0 0 / 12%), 0px 8px 5px -4px rgb(0 0 0 / 20%)";

export const CUSTOMER_SUPPORT_EMAIL = "archer-tech@idtdna.com";
export const SALES_EMAIL = "archer-sales@idtdna.com";
export const IDT_REQUEST_CONSULTATION = "https://go.idtdna.com/archer-request-a-consultation.html"
